import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Menu, Icon } from "capitalrx-components-2.0/lib/general";

import { ThemedMenuButton } from "../themed";
import "./LanguageSwitcher.scss";

export const LanguageSwitcher: FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (language: string): void => {
    i18n.changeLanguage(language);
  };

  const currentLanguageLabel = i18n.language === "es" ? "Español" : "English";

  return (
    <ThemedMenuButton
      className="translation-menu-button"
      label={
        <>
          <Icon color={{ r: 49, g: 62, b: 72, alpha: 255 }} name={"globe"} />
          {currentLanguageLabel}
        </>
      }
      appearance="text"
    >
      {currentLanguageLabel == "Español" && (
        <Menu.Item onClick={() => handleLanguageChange("en")} key="english-language">
          <>
            English
          </>
        </Menu.Item>
      )}
      {currentLanguageLabel == "English" && (
        <Menu.Item onClick={() => handleLanguageChange("es")} key="spanish-language">
          <>
            Español
          </>
        </Menu.Item>
      )}
    </ThemedMenuButton>
  );
};
